'use client'

import dynamic from 'next/dynamic'

// The comparison bar also renders nothing until client storage has a selection.
// Its narrow loading boundary preserves that initial empty state.
export const ComparedBarLazy = dynamic(() => import('./compared-bar').then((module) => module.ComparedBar), {
  loading: () => null,
})
